"use client";

import { FC } from "react";
import { motion, useReducedMotion } from "framer-motion";

const EASE: [number, number, number, number] = [0.25, 0.46, 0.45, 0.94];

/**
 * Заголовок страницы рациона с акцентным подчёркиванием под словом
 * «доставкой» — тем же, что в hero на главной.
 *
 * Отдельный клиентский компонент: сама страница серверная, а подчёркивание
 * рисуется анимацией framer-motion.
 */
export const RationTitle: FC<{ calories: string }> = ({ calories }) => {
  const reduceMotion = useReducedMotion();

  return (
    <h1 className="text-[22px] font-black leading-[1.12] tracking-tight text-whitePrimary min-[400px]:text-[26px] sm:text-[30px] md:text-[38px]">
      Рацион {calories} ккал в день
      <span className="block">
        с{" "}
        <span className="relative inline-block whitespace-nowrap">
          доставкой
          {/* До старта прорисовки линия полностью прозрачна: иначе из-за
              strokeLinecap="round" в начале торчала бы точка. */}
          <svg
            aria-hidden
            viewBox="0 0 220 12"
            fill="none"
            preserveAspectRatio="none"
            className="absolute -bottom-1 left-0 h-[6px] w-full md:-bottom-2 md:h-[9px]"
          >
            <motion.path
              d="M3 9C40 3.5 120 2 217 6.5"
              stroke="#d0ed1c"
              strokeWidth="5"
              strokeLinecap="round"
              initial={reduceMotion ? undefined : { pathLength: 0, opacity: 0 }}
              animate={reduceMotion ? undefined : { pathLength: 1, opacity: 1 }}
              transition={{
                pathLength: { duration: 0.7, delay: 0.35, ease: EASE },
                opacity: { duration: 0.01, delay: 0.35 },
              }}
            />
          </svg>
        </span>{" "}
        по Минску
      </span>
    </h1>
  );
};
